import { jsx as _jsx } from "react/jsx-runtime";
import { assertUnreachable } from '../../utils/assert';
import FixedColorPreview from './FixedColorPreview';
import FixedGradientPreview from './FixedGradientPreview';
export function ColorPreview(props) {
    const { color } = props;
    switch (color.kind) {
        case 'fixed': {
            return _jsx(FixedColorPreview, { color: color.color });
        }
        case 'fixedGradient': {
            return _jsx(FixedGradientPreview, { gradient: color.gradient });
        }
        default:
            assertUnreachable(color);
    }
}
//# sourceMappingURL=ColorPreview.js.map